module.exports = __webpack_public_path__ + "img/prize-01.d98b9385.png";